var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:( _obj = {}, _obj[_vm.$style.hasLinks] = _vm.isFormattingLinks, _obj ),domProps:{"innerHTML":_vm._s(_vm.sanitizedHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }